import { merge } from "lodash";

export async function fetchComAuth(url, options = {}) {
  const authUser = JSON.parse(sessionStorage.getItem('authUser')) || {}
  const token = authUser.token || ''

  const defaultHeaders = {
    
    'Authorization': `Bearer ${token}`
  }

  const mergedOptions = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...(options.headers || {})
    }
  }

  return fetch(url, mergedOptions)
}

export async function fetchComAuthJson(url, options = {}) {
  const authUser = JSON.parse(sessionStorage.getItem('authUser')) || {}
  const token = authUser.token || ''

  const defaultHeaders = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': `Bearer ${token}`,
    'chave': '18266602-6085-4532-992d-7bc2750b19f4'
  }

  const mergedOptions = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...(options.headers || {})
    }
  }

  return fetch(url, mergedOptions)
}

